<app-status-indicator
  [appearance]="appearance()"
  [status]="variant()"
  [meaning]="meaning()"
  [label]="label()"
/>
